<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="6" md="4">
        <b-card header="巴枪应用">
          <div v-html="androidQRcode"></div>
          <div slot="footer"><a v-bind:href="androidUrl">{{ androidFilename }}</a></div>
        </b-card>
      </b-col>
      <b-col sm="6" md="4">
        <b-card header="电脑应用">
          <div v-html="guiQRcode"></div>
          <div slot="footer"><a v-bind:href="guiUrl">{{ guiFilename }}</a></div>
        </b-card>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>
import { BrowserQRCodeSvgWriter } from '@zxing/library'
import axios from 'axios'

export default {
  data () {
    const codeWriter = new BrowserQRCodeSvgWriter()
    const xmlSerializer = new XMLSerializer()
    axios.get(axios.androidBackendUrl + '/apk/' + 'version').then(response => {
      console.log(response)
      this.androidFilename = 'android-' + response.data + '.apk'
      this.guiFilename = 'gui-' + response.data + '.exe'
      this.androidUrl = axios.androidBackendUrl + '/apk/' + this.androidFilename
      this.guiUrl = axios.androidBackendUrl + '/apk/' + this.guiFilename
      this.androidQRcode = xmlSerializer.serializeToString(codeWriter.write(axios.androidBackendUrl + '/apk/' + this.androidFilename, 300, 300))
      this.guiQRcode = xmlSerializer.serializeToString(codeWriter.write(axios.androidBackendUrl + '/apk/' + this.guiFilename, 300, 300))
    })
    return {
      androidFilename: null,
      androidUrl: null,
      androidQRcode: null,
      guiFilename: null,
      guiUrl: null,
      guiQRcode: null
    }
  }
}
</script>
